import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cycleMenuService } from "../../../services/menu-services/cycleMenu.service";

const initialState = {
    cycleDayPacksArray: [],
    selectedDay: 1,
    activePackId: null,
    activeMealId: null,
    activeIdMatching: null,
    status: null,
    error: null,
    trigger: 0,
};

const getAllCycleDayMenu = createAsyncThunk(
    "cycleDayMenuSlice/getAllCycleDayMenu",
    async (day, { rejectWithValue }) => {
        try {
            return await cycleMenuService.getByDay(day);
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);

const cycleDayMenuSlice = createSlice({
    name: "cycleDayMenuSlice",
    initialState,
    reducers: {
        setSelectedDay: (state, action) => {
            state.selectedDay = action.payload;
        },
        setActivePackId: (state, action) => {
            state.activePackId = action.payload;
        },
        setActiveMealId: (state, action) => {
            state.activeMealId = action.payload;
        },
        setActiveIdMatching: (state, action) => {
            state.activeIdMatching = action.payload;
        },
        changeTrigger: (state) => {
            state.trigger = state.trigger + 1;
        },
    },
    extraReducers: (builder) =>
        builder
            .addCase(getAllCycleDayMenu.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getAllCycleDayMenu.fulfilled, (state, action) => {
                state.status = "fulfilled";
                console.log("[cycleDayMenu] raw API response:", action.payload);
                state.cycleDayPacksArray = (action.payload || []).map(pack => {
                    console.log("[cycleDayMenu] pack:", pack.id, "cycleDayMenuDishes:", pack.cycleDayMenuDishes);
                    return {
                        ...pack,
                        menuDishes: pack.cycleDayMenuDishes || [],
                    };
                });
            })
            .addCase(getAllCycleDayMenu.rejected, (state, action) => {
                state.status = "rejected";
                state.cycleDayPacksArray = [];
                state.error = action.payload;
            }),
});

const { reducer: cycleDayMenuReducer, actions } = cycleDayMenuSlice;
const cycleDayMenuActions = {
    ...actions,
    getAllCycleDayMenu,
};

export { cycleDayMenuReducer, cycleDayMenuActions };
